import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab2 = ({ formData, onInputChange,errors }) => {
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];

    return (
        <>
            <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
                <div className="col-12">
                    <p className="boxLabel m-0">More Information</p>
                </div>


                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Department"
                                label="Department"
                                style={{
                                    height: "30px",
                                    ...(errors?.department ? { border: '1px solid red' } : {})
                                }}
                                value={formData.department}
                                onChange={(e) => onInputChange('department', e.target.value)}
                            />
                        </div>
                    </div>


                </div>




                {/* google check box */}
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>

                    <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
                            <input
                                type="checkbox"
                                checked={formData.unsubscribed || false}
                                onChange={(e) => {
                                    console.log('Checkbox changed to:', e.target.checked);
                                    onInputChange('unsubscribed', e.target.checked);
                                }}
                                className="form-check-input me-2"
                                style={{
                                    width: '15px', height: '15px',
                                    backgroundColor: formData.isGroupWarehouse ? '#270B79' : 'white',
                                    
                                    borderColor: "#270B79"
                                    
                                }}
                            />
                            Unsubscribed
                        </label>


                    </div>
                </div>

                {/* google check box */}


            </div>


        </>
    );
};

export default Tab2;